import {
  AnalyticsProperties,
  YANDEX_DIRECT_GOAL_EVENTS,
  YANDEX_FALLBACK_GOAL,
} from "../events";

declare global {
  interface Window {
    ym?: (...args: any[]) => void;
  }
}

export interface AnalyticsAdapter {
  init(): void;
  identify(userId: string | number, traits: AnalyticsProperties): void;
  clearIdentity(): void;
  pageView(
    url: string,
    options: {
      title?: string;
      referer?: string;
      params?: AnalyticsProperties;
    },
  ): void;
  track(eventName: string, payload: AnalyticsProperties): void;
}

const counterId = Number(
  process.env.REACT_APP_YANDEX_METRIKA_COUNTER_ID || 101742200,
);

let initialized = false;

const callMetrika = (...args: any[]) => {
  if (typeof window !== "undefined" && typeof window.ym === "function") {
    window.ym(counterId, ...args);
  }
};

export const yandexMetrikaAdapter: AnalyticsAdapter = {
  init() {
    if (initialized) {
      return;
    }

    initialized = true;
    callMetrika("init", {
      accurateTrackBounce: true,
      clickmap: true,
      defer: true,
      trackHash: false,
      trackLinks: true,
      webvisor: true,
    });
  },

  identify(userId, traits) {
    callMetrika("setUserID", String(userId));
    callMetrika("userParams", traits);
  },

  clearIdentity() {
    // У Метрики нет API очистки setUserID. Новая анонимная сессия не получает
    // идентификатор, а явный actor_user_id всё равно добавляется в каждое событие.
  },

  pageView(url, options) {
    callMetrika("hit", url, options);
  },

  track(eventName, payload) {
    const goalIdentifier = YANDEX_DIRECT_GOAL_EVENTS.includes(
      eventName as any,
    )
      ? eventName
      : YANDEX_FALLBACK_GOAL;
    callMetrika("reachGoal", goalIdentifier, payload);
  },
};

export const YANDEX_METRIKA_COUNTER_ID = counterId;
